import React from "react";

const SeparatorPreview = ({ config, classes }) => {
  let direction = config.direction || "horizontal";
  const styleObject = {
    width: direction === "horizontal" ? "100%" : `${config.separator_width || 2}px`,
    height: direction === "horizontal" ? `${config.separator_width || 2}px` : "100%"
  };

  return (
    <div className="d_flex justify_center align_center w_100 h_100 z-separator-outer">
      <div style={styleObject} className={`z-separator ${classes}`}></div>
    </div>
  );
};

export default SeparatorPreview;
